import React, { useState } from 'react';
import { Row, Col, Modal } from "react-bootstrap";
import { Button, IconButton, CardContent, Card, makeStyles, withStyles, Tooltip } from '@material-ui/core';
import SyringeIcon from '../../../../icons/SyringeBlue.svg';
import PhoneCallIcon from '../../../../icons/phoneCall.svg';
import DigitalApplicationIcon from '../../../../icons/digitalApplicationBlue.svg';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import ConvertibleIcon from '../../../../icons/convertibleBlue.svg';
import { Cancel, CheckCircle, MonetizationOn, MoneyOff } from "@material-ui/icons";
import PropTypes from 'prop-types';
import './ProductDetailModel.scss';

const TooltipColor = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    cursor: 'pointer'
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  textPrimary: {
    color: theme.palette.primary.main
  },
}));

export const ProductDetailsDialog = (props) => {
  const productDetailObj = props.quoteCardProps;
  const ratingCards = ['AMBest', 'SP', 'Moodys', 'Fitch', 'Comdex'];
  const cardObj = [
    {
      title: "Digital Application",
      iconName: <DigitalApplicationIcon />,
      shouldShow: productDetailObj.isDigitalProduct,
    },
    {
      title: "Convertible",
      iconName: <ConvertibleIcon />,
      shouldShow: productDetailObj.hasConvertibility
    },

    {
      title: "Phone Application",
      iconName: <PhoneCallIcon />,
      shouldShow: productDetailObj.requiresPhoneInterview,
    },
    {
      title: "Medical Exam",
      iconName: <SyringeIcon />,
      shouldShow: (productDetailObj.requiresMedicalExam && productDetailObj.requiresMedicalExam.toLowerCase() !== 'no'),
    },
  ];

  const ProductDetailsRatingCard = (props) => {
    return (
      <Card className="rating-card">
        <div className="rating-card-head">
          <img src={props.logo} alt={props.rater} className="img-fluid" />
        </div>
        <p className="rater">{props.rater}</p>
        <p className="rating">{props.rating}</p>
      </Card>
    );
  };

  const [tooltip, setTooltip] = useState(false);

  const handleTooltipClose = () => {
    setTooltip(false);
  };

  const handleTooltipOpen = () => {
    setTooltip(true);
  };
  const classes = useStyles();
  const hasRating =
    productDetailObj.ratingAMBest ||
    productDetailObj.ratingSP ||
    productDetailObj.ratingMoodys ||
    productDetailObj.ratingFitch ||
    productDetailObj.ratingComdex;

  return (
    <Modal className="product-details-dialog" show={props.isOpen} onHide={props.onClose} onClose={props.onClose}
      fullWidth={true} size="lg">
      <Modal.Body className="product-details-dialog-content">
        <IconButton aria-label="close" onClick={props.onClose} className="close-button">
          <CloseIcon />
        </IconButton>
        <Row>
          <Col md="3">
            <div className="pt-8 pb-2">
              <img className="carrier-logo-modal" src={productDetailObj.logoUrl} alt={`${productDetailObj.carrierName}`} />
            </div>
          </Col>
        </Row>
        <Row className="pb-2">
          <Col>
            <span className={`textRating ${classes.textPrimary}`}>{productDetailObj.rating} Rating</span>
          </Col>
        </Row>

        <Row>
          <Col md="8">
            <div className="product">
              <h4 className='select-title'>{productDetailObj.productName} &mdash; {productDetailObj.termLength} Year Term</h4>
            </div>
            <div className={`quote-amount-dollars-inner ${classes.textPrimary}`}>
              <div className='coverage-amount'><sup className='month-sup'>$ </sup>
              {productDetailObj.monthlyRate}
                <span className="quote-amount-mo"><sub className='month-sub'>/mo</sub></span>
              </div>
            </div>
          </Col>
          <Col md="4" className="d-flex justify-content-end">
            <span>
              {!props.hideSelect &&
                <Button className={`apply ${productDetailObj.hideSelect ? "d-none" : ''}`}
                  color="primary"
                  variant="contained"
                  onClick={props.quote.onClick}>
                  Select
                </Button>
              }
            </span>
          </Col>
        </Row>
        <Row>
          <Col>
            <Stats
              underwritingTimeTypical={productDetailObj.underwritingTimeTypical}
              additionalOptionsStars={productDetailObj.additionalOptionsStars}
              requiresMedicalExam={productDetailObj.requiresMedicalExam}
              monthlyRate={productDetailObj.monthlyRate}
              rating={productDetailObj.rating}
            />
          </Col>
        </Row>

        <div className="product-details-info mt-4 mb-4">{props.productDetails}</div>
        <Row className='application-main'>
          <h5 className="application-section mb-2">Application Process</h5>
          <p className="grey-text">
            {props.applicationInformation ? props.applicationInformation : (
              <span>
                This product's application process can take up to 15 days to complete. Not everyone who completes it is
                required to take a medical exam, but 20% of the time those who apply must complete medical exam. Based on
                what you've told us there is a 50% chance that you will be able to purchase this product without a medical
                exam.
              </span>
            )}
          </p>
        </Row>
        <Row className='term-card' >
          {cardObj.map((item, i) => {
            if (item.shouldShow)
              {return (
                <Card className="card-vertical d-flex flex-column " variant="elevation" key={i}>
                  <CardContent className='cardDiv'>
                    <Row className={`justify-content-center ${classes.textPrimary}`}>
                      {item.iconName}
                    </Row>
                    <div className="d-flex justify-content-center mt-1">
                      <p className='card-title text-center'>{item.title}</p>
                    </div>
                  </CardContent>
                </Card>

              );}
            return null;
          })}
        </Row>
        <div className="additional-options">
          <h5>Additional Options</h5>
          <Row className="mt-2 mb-2">
            <Col md={productDetailObj.hasConvertibility ? '4' : '12'}>
              <p className="option-title ">Convertibility</p>
              <div className="d-flex mt-2">
                {productDetailObj.hasConvertibility ? (
                  <span className='price-free'>
                    <CheckCircle className="mr-1" />
                    <span className='convertible-title'>This product is convertible.</span>
                  </span>
                ) : (
                  <span className='price-red'>
                    <Cancel className="mr-1" />
                    <span className='convertible-title'>This product is not convertible.</span>
                  </span>
                )}
              </div>
            </Col>
            {productDetailObj.hasConvertibility && (
              <Col md="8">
                <p className="grey-text" dangerouslySetInnerHTML={{ __html: productDetailObj.convertibility }} />
              </Col>
            )}
          </Row>
          {(productDetailObj.availableRiders && productDetailObj.availableRiders.length > 0) && (
            <Row className="mt-4">
              <Col>
                <h5>Available Policy Riders
                  <Tooltip className="toolInfo ml-2"
                    title="Riders add benefits to or change the term of an insurance policy.">
                    <TooltipColor role="tooltip" onClose={handleTooltipClose} open={tooltip} leaveTouchDelay={5000}>
                      <button id="riders" role="tooltip" aria-label="more about riders" className="quote-tooltip"
                        onMouseOver={handleTooltipOpen} onClick={handleTooltipOpen} tabIndex="0"
                        aria-disabled="true" aria-describedby="riders">
                        <InfoIcon color="action" />
                      </button>
                    </TooltipColor>
                  </Tooltip>
                </h5>
              </Col>
            </Row>
          )}

          {productDetailObj.availableRiders &&
            productDetailObj.availableRiders.length > 0 &&
            productDetailObj.availableRiders.map((r, index) => {
              return (
                <Row key={index} className="py-1 px-2">
                  <Col md="4">
                    <p className="option-title">{r.rider}</p>
                    <div className="option-cost-details mt-1">
                      {r.additionalCost && (
                        <span className="additional"><MonetizationOn className="mr-1" /> Additional Cost</span>
                      )}
                      {!r.additionalCost && (
                        <span className={`noAdditional ${classes.textPrimary}`}><MoneyOff className="mr-1" /> No Additional Cost</span>
                      )}
                    </div>
                  </Col>
                  <Col md="8">
                    <p dangerouslySetInnerHTML={{ __html: r.description }} className="grey-text" />
                  </Col>
                </Row>
              );
            })}
        </div>

        {hasRating && (
          <div className="ratings">
            <h5>Insurance Carrier Ratings</h5>
            <ul className="d-flex rating-cards">
              {ratingCards.map((ratingType) => (
                productDetailObj[`rating${ratingType}`] && (
                  <li key={ratingType}>
                    <ProductDetailsRatingCard
                      logo={`/logos/ratings/${ratingType.toLowerCase()}.jpg`}
                      rater={ratingType}
                      rating={productDetailObj[`rating${ratingType}`]}
                    />
                  </li>
                )
              ))}
            </ul>
          </div>
        )}
        {productDetailObj.productName === 'HavenTerm' ? (
          <div className="mt-4">
            <h3 className=" text-center">Disclosure</h3>
            <p className="grey-text">{productDetailObj.disclosureDetail}</p>
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  )
    ;
};

const Stats = (props) => {
  return (
    <div className="product-details-stats">
      <Row>
        <Col className="stats typically-takes" md={4} lg={3}>
          <p className="customize-title">Typically Takes</p>
          <p className="customize-text">{props.underwritingTimeTypical}</p>
        </Col>

        <Col className="stats typically-takes" md={4} lg={3}>
          <p className="customize-title">Medical Exam</p>
          <p className="customize-text">{props.requiresMedicalExam}</p>
        </Col>
        <Col className="stats" md={3} lg={2}>
          <p className="customize-title">Rider Cost</p>
          <p className="customize-text">{props.riderCost ? props.riderCost : "N/A"}</p>
        </Col>
      </Row>
    </div>
  );
};

ProductDetailsDialog.propTypes = {
  logo: PropTypes.string,
  rater: PropTypes.string,
  rating: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  hideSelect: PropTypes.bool,
  quote: PropTypes.object,
  productDetails: PropTypes.object,
  applicationInformation: PropTypes.object,
  underwritingTimeTypical: PropTypes.number,
  requiresMedicalExam: PropTypes.bool,
  riderCost: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/ProductDetailModel.js